<template>
  <el-form :model="formData" ref="form" label-suffix="：">
    <el-row :gutter="20">
      <el-col :span="8" :xs="12">
        <el-form-item label="果园名称"> {{ formData.plantationName || '-' }} </el-form-item>
      </el-col>
      <el-col :span="8" :xs="12">
        <el-form-item label="果园区域">
          {{ formData.locDetails && formData.locDetails.split(',').slice(3).join('') }}
        </el-form-item>
      </el-col>
      <el-col :span="8" :xs="12">
        <el-form-item label="采摘日期">
          {{ formData.pickingDateTime ? parseTime(formData.pickingDateTime, '{y}-{m}-{d}') : '-' }}
        </el-form-item>
      </el-col>
      <el-col :span="8" :xs="12">
        <el-form-item label="园主/场长"> {{ formData.ownerName || '-' }} </el-form-item>
      </el-col>
      <el-col :span="16" :xs="12">
        <el-form-item label="联系方式"> {{ formData.ownerContact || '-' }} </el-form-item>
      </el-col>
      <el-col :span="24">
        <div style="height: 1px; background-color: #ccc"></div>
      </el-col>
      <el-col :span="8" :xs="12">
        <el-form-item label="车牌号"> {{ formData.licensePlateNumber || '-' }} </el-form-item>
      </el-col>
      <el-col :span="8" :xs="12">
        <el-form-item label="锁号"> {{ formData.lockNumber || '-' }} </el-form-item>
      </el-col>
      <el-col :span="8" :xs="12">
        <el-form-item label="运输时间">
          {{ formData.freightDateTime ? parseTime(formData.freightDateTime, '{y}-{m}-{d} {h}:{i}') : '-' }}
        </el-form-item>
      </el-col>
      <el-col :span="8" :xs="12">
        <el-form-item label="产品名称"> {{ formData.cropBrandKeyValue || '-' }} </el-form-item>
      </el-col>
      <el-col :span="8" :xs="12">
        <el-form-item label="规格"> {{ getSpec() || '-' }} </el-form-item>
      </el-col>
      <el-col :span="8" :xs="12">
        <el-form-item label="监园人员">
          {{
            formData.supervisorIdList
              ? JSON.parse(formData.supervisorIdList)
                  .map((item) => item.userName)
                  .join(',')
              : '-'
          }}
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: 'BaseDetail',
  components: {
  },
  props: {
    formData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      
    }
  },
  mounted() {

  },
  methods: {
    getSpec() {
      const arr = [
        this.formData.ripenessLevelSpecAttrValueKey,
        this.formData.locDetails?.slice(this.formData.locDetails?.lastIndexOf(',') + 1),
        this.formData.cultivationMethodSpecValueKey,
      ]
      return arr.filter((item) => !!item).join('-')
    },
  },
}
</script>

<style scoped lang="less">

::v-deep {
  .el-form-item {
    margin-bottom: 0;
  }
  .el-form-item__label {
    color: #000;
  }
}

.btn-buttons {
  position: fixed;
  bottom: 50px;
  right: 20px;
  z-index: 999;
}
</style>
